import React, { FC, useMemo } from 'react';

import { Form, Formik } from 'formik';

import BasicModal from '../../components/modals/basicModal';

import aampeTheme from '../../constants/aampeTheme';
import { ModalHeaderStyle } from 'views/attributes/constants';

import { titlecase } from 'helpers/sanitize.helper';

import { EntityPermissionUsers, UserRole } from 'models/user.model';

import ShareEditModalBody from './ShareEditModalBody';
import ShareEditModalFooter from './ShareEditModalFooter';
import { EntityPermissionUserFormikContext } from './constant';

interface ShareEditModalProps {
    onClose: () => void;
    entityPermissionUsers: EntityPermissionUsers[];
    formulaId: number;
    hasWriteAccess: boolean;
}
const ShareEditModal: FC<ShareEditModalProps> = ({
    onClose,
    entityPermissionUsers,
    formulaId,
    hasWriteAccess,
}) => {
    const headerStyle = {
        ...ModalHeaderStyle,
        padding: aampeTheme.spacing4(6),
        fontSize: aampeTheme.size.font.text,
        fontWeight: aampeTheme.weights.heavy,
        backgroundColor: aampeTheme.colors.white,
        paddingBottom: 0,
    };

    const editorUsers = useMemo<EntityPermissionUsers[]>(() => {
        return entityPermissionUsers.filter(
            (users) => users.role == UserRole.EDITOR,
        );
    }, [entityPermissionUsers]);

    const managerUsers = useMemo<EntityPermissionUsers[]>(() => {
        return entityPermissionUsers.filter(
            (users) => users.role == UserRole.MANAGER,
        );
    }, [entityPermissionUsers]);

    const adminUsers = useMemo<EntityPermissionUsers[]>(() => {
        return entityPermissionUsers.filter(
            (users) => users.role == UserRole.ADMIN,
        );
    }, [entityPermissionUsers]);

    const initialValues = useMemo<EntityPermissionUserFormikContext>(() => {
        return {
            groups: {
                editors: editorUsers,
                managers: managerUsers,
                admins: adminUsers,
            },
            selectedEditors: [],
            selectedGroup: undefined,
        };
    }, [editorUsers, managerUsers, adminUsers]);

    return (
        <>
            <Formik
                initialValues={initialValues}
                onSubmit={() => {}}
                validateOnChange
                validateOnMount
                validateOnBlur
                enableReinitialize
            >
                {({ setFieldValue, values }) => {
                    const headerText = values.selectedGroup
                        ? `${titlecase(values.selectedGroup)} ${
                              values.groups[values.selectedGroup].length
                          }`
                        : hasWriteAccess
                        ? 'Share Edit Access'
                        : 'View Access Only';
                    return (
                        <Form>
                            <BasicModal
                                backIcon={values.selectedGroup ? true : false}
                                onBackIconClick={() => {
                                    setFieldValue('selectedGroup', undefined);
                                }}
                                childContainerStyle={{
                                    overflow: 'auto',
                                    padding: 'undefined',
                                }}
                                containerBodyStyle={{
                                    display: 'flex',
                                    flexDirection: 'column',
                                }}
                                width={'480px'}
                                header={headerText}
                                headerStyle={headerStyle}
                                footer={
                                    <ShareEditModalFooter onClose={onClose} />
                                }
                                footerStyle={{
                                    display: 'flex',
                                    justifyContent: 'space-between',
                                    borderTop: `1px solid ${aampeTheme.colors.bordersWG01}`,
                                    position: 'sticky',
                                    alignSelf: 'end',
                                    width: '100%',
                                }}
                            >
                                <ShareEditModalBody
                                    formulaId={formulaId}
                                    hasWriteAccess={hasWriteAccess}
                                />
                            </BasicModal>
                        </Form>
                    );
                }}
            </Formik>
        </>
    );
};

export default ShareEditModal;
